module.exports = __webpack_public_path__ + "img/110.68f62f24.svg";